//import htmlDocx from 'html-docx-js/dist/html-docx'
import {saveAs} from 'file-saver'
import CustomStyles from '@/components/partials/CustomStyles';
import html2canvas from "html2canvas";
import {Notification} from 'element-ui';
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import {Loading} from "element-ui";

export const wordMix = {
    components:{
        Notification
    },

    computed: {
        ...mapGetters('requests', {
            inboxForm: "inboxForm",
            filters: "filters",
            manageTemplates: "manageTemplates"
        }),
        ...mapGetters('templates', {
            templateForm: "templateForm",
        }),
    },

    methods: {
        ...mapActions('requests', [
            'addTemplates'
        ]),

        removeTab(targetName) {

            this.$confirm('Se eliminará el registro seleccionado', 'Alerta', {
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {


                this.$message({
                    type: 'success',
                    message: 'Se eliminó el registro'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Cancelado'
                });
            });
        },

        declinedService(letter) {

            let _this = this;

            this.$prompt('¿Está seguro de rechazar el Documento?', 'Alerta', {
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                inputPlaceholder: 'Escribe un comentario',
                type: 'warning'
            }).then(({value}) => {

                _this.$store.dispatch('loading/spinner', {
                    msg: 'La carta se está rechazando...',
                    status: true
                }, {root: true});

                let formData = {
                    letter_id: letter.id,
                    status_id: 7,
                    comments: 'Comentario hecho por el Firmante  ' + this.$store.state.user.fullname + ' *  ' + value + ' *  '
                };
                window.axios.post('/api/word-save-status', formData)
                    .then((response) => {
                        _this.$store.dispatch('loading/spinner', {}, {root: true});

                        const parsedResponse = response.data;
                        if (parsedResponse && parsedResponse.success == true) {
                            _this.$router.push({path: '/registros/exhortos'});
                        }

                    })
                    .catch((err) => {
                        console.log(err);
                        _this.$store.dispatch('loading/spinner', {}, {root: true});
                        let msg = 'No se pudo completar la acción';
                        if (err.response &&
                            err.response.data &&
                            err.response.data.message
                            && err.response.status == 400) {
                            msg = err.response.data.message;
                        }
                        _this.$store.dispatch('notifications/error', {msg: msg}, {root: true});
                    });


            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Cancelado'
                });
            });

        },
        getInfoLetter(valueKey, letter, itemMain, valueDescription, item) {


            let valueTmp = '';
            if (valueKey == 'current_date') {

                valueTmp = moment(new Date()).format("D [de] MMMM [de] YYYY ");

            } else if (valueKey == 'expedient') {

                valueTmp = letter.case_file.expedient;

            } else if (valueKey == 'judgment_type_id') { //  judgment_type_id tipo de Juicio

                valueTmp = letter.judment ? letter.judment.name : '';

            } else if (valueKey == 'applicant_people') { //  Promovente y/o Demandante


                let keyItemApplicant = 0;
                let keyItemApplicantTotal = 0;

                letter.applicant_defendants.forEach((itemApplicant) => {
                    if (itemApplicant.applicantOrDefendant === 1) {
                        keyItemApplicantTotal++;
                    }
                });

                letter.applicant_defendants.forEach((itemApplicant) => {
                    if (itemApplicant.applicantOrDefendant === 1) {
                        let full_name = itemApplicant.name + (itemApplicant.firstName ? ' ' + itemApplicant.firstName : '') + (itemApplicant.secondName ? ' ' + itemApplicant.secondName : '');

                        if (keyItemApplicantTotal == (keyItemApplicant + 1) && keyItemApplicantTotal > 1) {
                            valueTmp = valueTmp + ' y ' + full_name;
                        } else if (keyItemApplicant > 0) {
                            valueTmp = valueTmp + ', ' + full_name;
                        } else {
                            valueTmp = valueTmp + '' + full_name;
                        }


                        keyItemApplicant++;
                    }
                });

            } else if (valueKey == 'defendants_people') { //  Demandado

                let keyItemApplicant = 0;

                let keyItemApplicantTotal = 0;

                letter.applicant_defendants.forEach((itemApplicant) => {
                    if (itemApplicant.applicantOrDefendant === 2) {
                        keyItemApplicantTotal++;
                    }
                });

                letter.applicant_defendants.forEach((itemApplicant) => {
                    if (itemApplicant.applicantOrDefendant === 2) {
                        let full_name = itemApplicant.name + (itemApplicant.firstName ? ' ' + itemApplicant.firstName : '') + (itemApplicant.secondName ? ' ' + itemApplicant.secondName : '');


                        if (keyItemApplicantTotal == (keyItemApplicant + 1) && keyItemApplicantTotal > 1) {
                            valueTmp = valueTmp + ' y ' + full_name;

                        } else if (keyItemApplicant > 0) {

                            valueTmp = valueTmp + ', ' + full_name;
                        } else {

                            valueTmp = valueTmp + '' + full_name;
                        }


                        keyItemApplicant++;
                    }
                });

            } else if (valueKey == 'nameOfGeneralAdministrator') { //Nombre de Administrador General o Administrador


                letter.last_flows.forEach((item) => {
                    if (item.typeFlow === 4) {
                        valueTmp = item.user.employee.full_name;
                    }
                });


            } else if (valueKey == 'positionOfGeneralAdministrator') { //Nombre de Administrador General o Administrador


                letter.last_flows.forEach((item) => {
                    if (item.typeFlow === 4) {
                        valueTmp = item.user.job_profile.name;
                    }
                });


            } else if (valueKey == 'validatorDictaminator') { // Turnado a.- Validador –Abogado dictaminador
                letter.last_flows.forEach((item) => {
                    if (item.typeFlow === 2) { // VALIDADOR
                        valueTmp = item.user.employee.determinant;
                    }
                });
                letter.last_flows.forEach((item) => {
                    if (item.typeFlow === 3) {// DICTAMINADOR
                        valueTmp = valueTmp + ', ' + item.user.employee.determinant;
                    }
                });
            } else if (valueKey == 'web_status_id') {

                if (this.current_config && this.current_config.sicre_cat_document_type_id === 20) {
                    valueTmp = letter.web_status ? letter.web_status.english : '';
                } else {
                    valueTmp = letter.web_status ? letter.web_status.name : '';
                }

            } else if (valueKey == 'cat_agreement_name_titular') { //Nombre de Titular de la Representación diplomatica o consular
                valueTmp = letter.cat_agreement ? letter.cat_agreement.name_titular : '';

            } else if (valueKey == 'office_principal') {

                valueTmp = itemMain.officePrincipal ? itemMain.officePrincipal : '';

            } else if (valueKey == 'destination_country_id') { // País requerido destino
                valueTmp = letter.destination_country ? letter.destination_country.oficial_country_name : '';

            } else if (valueKey == 'origin_country_id') { // País requirente
                valueTmp = letter.origin_country ? letter.origin_country.oficial_country_name : '';

            } else if (valueKey == 'cat_agreement_diplomatic_or_consular_representation') { // Representación Diplómatica o Consular

                if (itemMain && itemMain.cat_office && itemMain.cat_office.nombre) {

                    valueTmp = itemMain.cat_office.nombre;
                    valueTmp = valueTmp.trim();

                } else if (itemMain && itemMain.cat_office_branch && itemMain.cat_office_branch.Consulado) {
                    valueTmp = itemMain.cat_office_branch.Consulado;
                    valueTmp = valueTmp.trim();

                } else if (itemMain.office) {
                    valueTmp = itemMain.office;
                    valueTmp = valueTmp.trim();
                } else if (itemMain.officeBranch) {
                    valueTmp = itemMain.officeBranch;
                    valueTmp = valueTmp.trim();
                }


            } else if (valueKey == 'office_type_id') { // tipo de consulado convenio 11


                if (itemMain && itemMain.cat_office && itemMain.cat_office.cat_type_office) {

                    valueTmp = itemMain.cat_office.cat_type_office.name;

                    valueTmp = valueTmp.trim();

                } else if (itemMain && itemMain.cat_office_branch && itemMain.cat_office_branch.office && itemMain.cat_office_branch.office.cat_type_office) {
                    valueTmp = itemMain.cat_office_branch.office.cat_type_office.name;
                    valueTmp = valueTmp.trim();

                } else if (itemMain && itemMain.cat_type_office) {

                    valueTmp = itemMain.cat_type_office.name;
                    valueTmp = valueTmp.trim();

                } else if (itemMain && itemMain.type_office) {

                    valueTmp = itemMain.type_office.trim();
                }


            } else if (valueKey == 'consulate_entity') { // entidad consulado convenio 11


                if (itemMain.cat_state) {
                    valueTmp = itemMain.cat_state.Tx_Descripcion;
                } else {
                    valueTmp = itemMain && itemMain.state ? itemMain.state : '';
                }


            } else if (valueKey == 'consulate_country') { // país del consulado convenio 11


                if (itemMain && itemMain.cat_office && itemMain.cat_office.cat_country) {

                    valueTmp = itemMain.cat_office.cat_country.name;
                    valueTmp = valueTmp.trim();

                } else if (itemMain && itemMain.cat_office_branch && itemMain.cat_office_branch.office && itemMain.cat_office_branch.office.cat_country) {
                    valueTmp = itemMain.cat_office_branch.office.cat_country.name;
                    valueTmp = valueTmp.trim();
                } else if (itemMain && itemMain.country) {
                    valueTmp = itemMain && itemMain.country ? itemMain.country.oficial_country_name : '';
                }


            } else if (valueKey == 'cat_agreement_tribunal_name') { // Tribunal Superior de Justicia

                valueTmp = letter.cat_agreement && letter.cat_agreement.tribunal ? letter.cat_agreement.tribunal.name : '';

                //
            } else if (valueKey == 'autoridad_requerida') { //autoridad_requiriente

                valueTmp = letter.cat_agreement ? letter.cat_agreement.autoridad_requerida : ''


                //
            } else if (valueKey == 'person_to_notify_name') {

                valueTmp = (itemMain && itemMain.name ? itemMain.name : '') + (itemMain && itemMain.firstName ? ' ' + itemMain.firstName : '') + (itemMain && itemMain.secondName ? ' ' + itemMain.secondName : '');

            } else if (valueKey == 'person_to_notify_street') {

                valueTmp = itemMain && itemMain.street ? itemMain.street : '';

            } else if (valueKey == 'person_to_notify_number') {

                valueTmp = itemMain && itemMain.ext_number ? itemMain.ext_number : '';
                if (itemMain && itemMain.int_number) {

                    valueTmp = valueTmp + ' ' + itemMain.int_number;
                }

            } else if (valueKey == 'person_to_notify_neighborhood') {
                valueTmp = itemMain && itemMain.colony ? itemMain.colony : '';

            } else if (valueKey == 'person_to_notify_delegation') {

                if (itemMain.cat_municipality) {
                    valueTmp = itemMain.cat_municipality.Tx_Mun_County_Completa
                } else {
                    valueTmp = itemMain && itemMain.municipality ? itemMain.municipality : '';
                }

            } else if (valueKey == 'person_to_notify_city') {


                if (itemMain.cat_state) {
                    valueTmp = itemMain.cat_state.Tx_Descripcion;
                } else {
                    valueTmp = itemMain && itemMain.state ? itemMain.state : '';
                }


            } else if (valueKey == 'person_to_notify_code_area') {
                valueTmp = itemMain && itemMain.area_code ? itemMain.area_code : '';

            } else if (valueKey == 'person_to_notify_code_country') {
                valueTmp = itemMain && itemMain.country ? itemMain.country.oficial_country_name : '';

            } else if (valueKey == 'cat_agreement_name_description_of_the_diligence') {

                valueTmp = letter.cat_agreement ? letter.cat_agreement.descripcion_diligencia : '';


            } else if (valueKey == 'recipients_name') {

                if (item.to_people) {
                    valueTmp = (item && item.to_people.name ? item.to_people.name : '');
                }

            } else if (valueKey == 'recipients_position') {

                valueTmp = item && item.to_people && item.to_people.position ? item.to_people.position : '';

            } else if (valueKey == 'recipients_institution') {

                valueTmp = item && item.to_people && item.to_people.institution ? item.to_people.institution : '';

            } else if (valueKey == 'procedure_name') { // Tribunal Superior de Justicia

                valueTmp = letter.procedure && letter.procedure.name ? letter.procedure.name : '';

            } else if (valueKey == 'acuse_status') {

                valueTmp = letter.acuse_status && letter.acuse_status.name ? letter.acuse_status.name : '';
            } else {


                Object.keys(letter).forEach((letterKey) => {
                    if (letterKey == valueKey) {


                        valueTmp = letter[letterKey];
                        // specifySender Nombre Autoridad requirente
                        // courtRecord Expediente Juzgado

                    }
                });
            }


            if (valueTmp === null) {
                valueTmp = 'Este campo no fué capturado'
            }

            if (valueTmp == '') {
                valueTmp = valueDescription
            }

            return valueTmp;
        },


        replaceImages(elementId) {
            // esta funcion permite reemplazar el host del html para asignar la ruta dinamica de nuestro servidor
            let contentDocument = document.getElementById(elementId);
            var regularImages = contentDocument.querySelectorAll("img");


            [].forEach.call(regularImages, (imgElement) => {

                var imgsrc = $(imgElement).attr('src');
                var getLocation = function (href) {
                    var l = document.createElement("a");
                    l.href = href;
                    return l;
                };
                var l = getLocation(imgsrc);
                //console.log(l.hostname);
                //console.log(l.pathname);
                imgElement.setAttribute('src', this.host + l.pathname);
                //imgElement.setAttribute('crossOrigin', "Anonymous");

            });


            return true;

        },

        convertImagesToBase64(contentDocument) {

            return new Promise((resolve, reject) => {


                var regularImages = contentDocument.querySelectorAll("img");


                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');


                if (regularImages && regularImages.length > 0) {

                    [].forEach.call(regularImages, (imgElement, key) => {

                        var img = new Image;

                        function convertImgToDataURLviaCanvas(url, imageWidth, imageHeight, callback, outputFormat) {
                            img.onload = () => {

                                var width = imageWidth && imageHeight ? imageWidth : img.width;
                                var height = imageWidth && imageHeight ? imageHeight : img.height;


                                //-->
                                var oc = document.createElement('canvas'),
                                    octx = oc.getContext('2d');

                                oc.width = img.width;
                                oc.height = img.height;

                                octx.drawImage(img, 0, 0);
                                oc.width = width;
                                oc.height = height;
                                octx.drawImage(img, 0, 0, oc.width, oc.height);

                                var dataURL = oc.toDataURL(outputFormat);

                                callback(dataURL);

                            };
                            img.src = url;
                        }


                        var imageUrl = $(imgElement).attr('src');
                        var imageWidth = parseInt($(imgElement)[0].style.width); // 4.45 cm is the same 253 -> 1 cm = 37.795276px http://localhost:8000/img/word/image003.png
                        var imageHeight = parseInt($(imgElement)[0].style.height);// 3.78 cm = 215 px


                        if (isNaN(imageWidth) || isNaN(imageHeight)) {
                            imageWidth = null;
                            imageHeight = null;
                        }


                        var convertFunction = convertImgToDataURLviaCanvas;

                        convertFunction(imageUrl, imageWidth, imageHeight, function (base64Img) {
                            imgElement.setAttribute('src', base64Img);
                            if ((key + 1) === regularImages.length) {
                                resolve(true);
                            }
                        });
                    });


                } else {
                    resolve(true);
                }
            }, error => {
                reject(false);
            });


        },

        generateWaterMarkBase64(current_config) {

            return new Promise((resolve, reject) => {

                if (current_config && current_config.url_watermark) {

                    var imageUrl = this.host + current_config.url_watermark;
                    var dataURL;
                    var img = new Image,
                        canvas = document.createElement("canvas"),
                        ctx = canvas.getContext("2d");


                    function convertImgToDataURLviaCanvas(url, callback, outputFormat) {
                        img.onload = function () {
                            canvas.width = img.width;
                            canvas.height = img.height;
                            ctx.drawImage(img, 0, 0);
                            dataURL = canvas.toDataURL('image/jpeg');
                            callback(dataURL);
                            canvas = null;
                        };
                        img.src = url;
                    }

                    var convertFunction = convertImgToDataURLviaCanvas;
                    convertFunction(imageUrl, function (base64Img) {
                        resolve(base64Img);
                    });
                } else {
                    resolve(true);
                }


            }, error => {
                reject(false);
            });
        },


        generateWord(html, css, current_config, checklist, editing) {

            if (!html) {
                alert("El Word se encuentra vacío");
                return false;
            }

            let generateWaterMark = null;

            Promise.all([this.generateWaterMarkBase64(current_config)])
                .then((reponse) => {

                    generateWaterMark = reponse[0];



                    var content = `<html><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><title></title>`;

                    let contentTmp = content + ` </head><body style="word-break: break-word !important; word-wrap: break-word !important;"  lang=ES-MX><div>  ${html}</div></body></html>`;

                    let customHeader = '';
                    let customFooter = '';
                    var el = document.createElement('html');
                    /*el.setAttribute("xmlns:v", "urn:schemas-microsoft-com:vml");
                    el.setAttribute("xmlns:o", "urn:schemas-microsoft-com:office:office");
                    el.setAttribute("xmlns:w", "urn:schemas-microsoft-com:office:word");
                    el.setAttribute("xmlns:m", "http://schemas.microsoft.com/office/2004/12/omml");
                    el.setAttribute("xmlns:mv", "http://macVmlSchemaUri");
                    el.setAttribute("xmlns", "http://www.w3.org/TR/REC-html40");*/


                    el.innerHTML = contentTmp;

                    let tables = el.getElementsByTagName('table');
                    for (let table of tables) {
                        if ($(table).hasClass('main-header')) {//main-header
                            customHeader = table.innerHTML;//
                            table.remove();
                        }
                    }

                    let footerDivs = el.getElementsByTagName('div');

                    for (let table of footerDivs) {
                        if ($(table).hasClass('main-footer')) {//main-footer
                            customFooter = table.innerHTML; //
                            table.remove();
                        }
                    }

                    for (let table of footerDivs) {
                        if ($(table).hasClass('MsoFooter')) {
                            table.remove();
                        }
                    }


                    let CustomWaterMark = ``;


                    let CustomWaterMark2 = ``;


                    let customHeaderFooter = ``;


                    let header = ``;

                    let mainDivs = el.getElementsByTagName('div');
                    for (let mainDiv of mainDivs) {
                        if ($(mainDiv).hasClass('WordSection1')) {
                            var table = document.createElement('table'); //new table
                            table.setAttribute("id", "hrdftrtbl");
                            table.setAttribute("border", "0");
                            table.setAttribute("cellspacing", "0");
                            table.setAttribute("cellpadding", "0");
                            table.innerHTML = header;
                            mainDiv.append(table);
                        }

                    }

                    Promise.all([this.convertImagesToBase64(el)])
                        .then((reponse) => {


                            content = el.outerHTML;
                            content = content.replace(/\u200C/g, '');

                            let _hash = null;
                            if(this.templateForm.hash_id){
                                _hash = this.templateForm.hash_id
                            }else if(this.manageTemplates.templates && this.manageTemplates.templates[0].hash_id){
                                _hash = this.manageTemplates.templates[0].hash_id;
                                let _templates = {
                                    form: this.manageTemplates.form,
                                    sipac_request_id: this.manageTemplates.sipac_request_id,
                                    cat_procedure_id: this.manageTemplates.cat_procedure_id,
                                    templates: this.manageTemplates.templates,
                                    html: content,
                                    isGenerate: true
                                };
                                this.addTemplates(_templates);
                            }

                            var params = {
                                html: content,
                                checklist: checklist,
                                hash: _hash,
                                sipac_request_id: this.manageTemplates.sipac_request_id,
                            };


                            //this.$store.dispatch('notifications/info', {msg: 'Descargando...'}, {root: true});
                            let loadingInstance = Loading.service({
                                lock: true,
                                text: 'Descargando documento, espere...',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            });
                            axios.post('/api/papers/exportPdf', {params},{responseType: 'blob'})
                                .then(response => {
                                    const linkUrl = window.URL.createObjectURL(new Blob([response.data]));
                                    const link = document.createElement('a');
                                    link.href = linkUrl;

                                    link.setAttribute('download', `SIPAC-${moment( new Date() ).format('DD-MM-YYYY-HH:MM:SS')}.pdf`);
                                    document.body.appendChild(link);
                                    link.click();
                                    loadingInstance.close();
                                    Notification.closeAll();

                                })
                                .catch(error => {
                                    loadingInstance.close();
                                    this.transfer = false;
                                });


                            /*axios.post('/api/papers/exportPdf', _data).then(response => {

                            })
*/

                            /*var converted = htmlDocx.asBlob(content, {
                                size: current_config.legal === true || current_config.legal === 1 ? 'legal' : null,
                                orientation: current_config.orientation,
                                margins: {
                                    top: parseFloat(current_config.top ) * 566.9291338583,
                                    right: parseFloat(current_config.right) * 566.9291338583,
                                    bottom: parseFloat(current_config.bottom) * 566.9291338583,
                                    left: parseFloat(current_config.left) * 566.9291338583,

                                    header: parseFloat(current_config.header ) * 566.9291338583,
                                    footer: parseFloat(current_config.footer ) * 566.9291338583,

                                    gutter: current_config.gutter,
                                    height: current_config.height,
                                    width: current_config.width
                                }
                            });


                            let alias = window.moment().format('HH:mm:ss');
                            saveAs(converted, 'Documento-'+alias+'.docx');
                            var link = document.createElement('a');
                            link.href = (window.URL || window.webkitURL).createObjectURL(converted);
                            link.download = 'Documento.docx';
                            link.appendChild(
                                document.createTextNode('Haga clic aquí si su descarga no se inició automáticamente'));
                            //var downloadArea = document.getElementById('download-area');
                            //downloadArea.innerHTML = '';

                            return converted;*///url file blob

                        }).catch((err) => {
                        loadingInstance.close();
                        console.log("err generate word", err);

                    });

                }).catch((err) => {
                loadingInstance.close();
                console.log("err generate generateWaterMarkBase64", err);

            });

        },

        checkMark(current_config, CustomWaterMark, CustomWaterMark2) {
            let template = '';
            if (current_config.watermark === true || current_config.watermark === 1) {
                if (current_config.url_watermark == '/img/word/image004.png') {
                    template = CustomWaterMark2;
                } else {
                    template = CustomWaterMark;
                }
            }
            return template;

        }

    }
};

